import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ToastArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  padding: 0 28px;
`;

export const ToastRetryRow = styled.div`
  width: 692px;
  display: flex;
  justify-content: flex-end;
`;

export const FiltersSection = styled.div`
  padding: 0 28px;
`;

export const CardsSection = styled.div`
  padding: 16px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
